import { render } from "./AddSupport.vue?vue&type=template&id=b348bf5a&scoped=true&ts=true"
import script from "./AddSupport.vue?vue&type=script&lang=ts"
export * from "./AddSupport.vue?vue&type=script&lang=ts"

import "./AddSupport.vue?vue&type=style&index=0&id=b348bf5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b348bf5a"]])

export default __exports__